import React, { Fragment, useState, useEffect } from "react";
import { NotaryProfile } from "../../components"
import { NotaryAssign } from "../buttons";
import { RestHelper } from '../../helper/restHelper'


function AdminDisplaySimilarOrders( props ) {

    const [expanded, setExpanded] = useState({});
    const [showNotaryProfile, setShowNotaryProfile] = useState(false)
    const [profile, setProfile] = useState("")
    const [isLoaded, setIsLoaded] = useState(false)
    const [response, setResponse] = useState([])

    const api = RestHelper()

    function convertEpoch(value) {
        const date = new Date(value * 1000); // epochTime is in seconds

        // Format date to MM/DD/YYYY
        const formattedDate = date.toLocaleDateString('en-US'); // Adjust locale as needed

        // Format time to HH:MM AM/PM
        const formattedTime = date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });

        // Combine date and time
        const fullDateTime = `${formattedDate} ${formattedTime}`;

        return fullDateTime
    }

    const getProfile = (data) => {
        setProfile(data)
        setShowNotaryProfile(true)
    }

    const changeView = () => {
        setShowNotaryProfile(false)
    }

    const loadResponse = (e) => {
        setResponse(e[0]['message'])
        console.log(response)
    }

    useEffect(() => {
        if (!isLoaded) {
            setIsLoaded(true)
            const reqData = { 'requestId': props.summaryData }
            const options = {}
            api
                .postCreate('/find-comparison-orders', options, reqData)
                .then(res => loadResponse(res))
                .catch(err => console.log(err))
        }
    }, [])



    const toggleExpand = (notary) => {
        setExpanded((prev) => ({
            ...prev,
            [notary]: !prev[notary],
        }));
    };

    return (
        <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
            <h6 className="pl-4 mt-2 text-gray-900 font-semibold">Previous Orders in this Area</h6>
            <table className="min-w-full text-sm text-left text-gray-700">
                <thead className="bg-gray-100 text-gray-900 font-semibold">
                    <tr>
                        <th className="px-4 py-2 w-8"></th>
                        <th className="px-4 py-2">Notary Name</th>
                        <th className="px-4 py-2 text-center">Orders</th>
                        <th className="px-4 py-2 text-center">Average Fee ($)</th>
                    </tr>
                </thead>
                <tbody>
                    {response?.map((data) => {
                        // Sort orders by appt_numerical_time descending
                        const sortedOrders = [...data.orders].sort(
                            (a, b) => b.appt_numerical_time - a.appt_numerical_time
                        );
                        return (
                            <React.Fragment key={data.notary}>
                                {/* Summary Row */}
                                <tr
                                    className="border-b hover:bg-gray-50 cursor-pointer"
                                    onClick={() => toggleExpand(data.notary)}
                                >
                                    <td className="px-4 py-2 text-center text-gray-600">
                                        {expanded[data.notary] ? "▼" : "▶"}
                                    </td>
                                    <td className="px-2 py-1 fw-medium clickable-text" onClick={() => getProfile(data.notary)}>{data.notary_name}</td>
                                    <td className="px-4 py-2 text-center">{data.count}</td>
                                    <td className="px-4 py-2 text-center">
                                        ${data.average_fee.toFixed(2)}
                                    </td>
                                    <td><NotaryAssign requestId={props.summaryData} notary={data.notary} notary_name = {data.notary_name} onClickResponse={() => {props.closeWindow()}}/></td>
                                </tr>

                                {/* Expanded Detail View */}
                                {expanded[data.notary] && (
                                    <tr className="bg-light">
                                        <td colSpan="4" className="p-3">
                                            <div className="ps-3">
                                                <div className="table-responsive ps-3">
                                                    <table className="table table-sm text-secondary mb-0">
                                                        <thead className="bg-body-secondary">
                                                            <tr>
                                                                <th className="px-2 py-1 text-start">Date</th>
                                                                <th className="px-2 py-1 text-start">Location</th>
                                                                <th className="px-2 py-1 text-end">Fee ($)</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {(sortedOrders || []).map((order, idx) => {
                                                                const dateValue = order?.appt_numerical_time
                                                                    ? new Date(order.appt_numerical_time * 1000).toLocaleString()
                                                                    : '-';

                                                                const city = order?.appt_city || '';
                                                                const state = order?.appt_state || '';
                                                                const location =
                                                                    city || state ? [city, state].filter(Boolean).join(', ') : '-';

                                                                const rawFee = order?.appt_offer;
const fee = rawFee !== undefined && rawFee !== null && !isNaN(rawFee)
  ? `$${parseFloat(rawFee).toFixed(2)}`
  : '-';

                                                                return (
                                                                    <tr key={idx} className="border-bottom last:border-0">
                                                                        <td className="px-2 py-1">{dateValue}</td>
                                                                        <td className="px-2 py-1">{location}</td>
                                                                        <td className="px-2 py-1 text-end">
                                                                            <span className="clickable-text">{fee}</span>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                )}
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
            {showNotaryProfile &&
                <Fragment>
                    <div className='container border rounded bg-light'>
                        <div className='row rounded bg-white'>
                            <button className="close ml-3 mb-2 mt-2" aria-label="Close" onClick={() => changeView()}>
                                <span aria-hidden='false'>&times;</span>
                            </button>
                        </div>
                        <div>
                            <NotaryProfile profile={profile} />
                        </div>
                    </div>
                </Fragment>
            }
        </div>
    );
}


export default AdminDisplaySimilarOrders;
